export default {"src":"/_next/static/media/badge-appstore-ru.9b69bd27.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};